"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateApplication = exports.createApplication = exports.getApplications = void 0;
const zenithApiPrivate_1 = __importDefault(require("../utils/zenithApiPrivate"));
const config_1 = __importDefault(require("../utils/config"));
const constants_1 = require("../constants");
const { zenithConfigApi } = (0, config_1.default)();
const applicationsEndpoint = `${zenithConfigApi}${constants_1.routes.APPLICATIONS}`;
/**
 * Axios wrapper function to fetch one or more application
 *
 * @param applicationId - Optional param to supply an ID to fetch data for that item
 */
const getApplications = (applicationId) => () => {
    const url = (applicationId && applicationId !== '')
        ? `${applicationsEndpoint}/${applicationId}`
        : applicationsEndpoint;
    return zenithApiPrivate_1.default.get(url)
        .then((res) => res.data.data);
};
exports.getApplications = getApplications;
/**
 * Axios wrapper function to create a new application
 *
 * @param application - data for a new application
 */
const createApplication = (application) => (zenithApiPrivate_1.default.post(applicationsEndpoint, application)
    .then((res) => res));
exports.createApplication = createApplication;
/**
 * Axios wrapper function to update an existing application
 *
 * @param application - update information for the application
 */
const updateApplication = (application) => {
    const url = `${applicationsEndpoint}/${application.appId}`;
    return zenithApiPrivate_1.default.put(url, application)
        .then((res) => res);
};
exports.updateApplication = updateApplication;
